<template>
  <p class="pb-8 text-foreground text-body-md lg:text-body-lg font-ui max-w-[720px] text-left md:text-center">
    <slot />
  </p>
</template>
